// Shared page frame for the passenger pages (voucher, voucher lookup, wallet, wallet handoff,
// consent, unsubscribe): the same "above the clouds" sky in the airline's colours as the staff
// sign-in pages, behind the page's own white panel(s). The page itself still sets the airline
// brand (setCompanyStyle) as soon as its data arrives; until then the sky is a neutral slate,
// never Vamos blue.
import React from 'react'
import PropTypes from 'prop-types'
import SkyBackdrop from './SkyBackdrop'
import './BrandedPage.scss'

const BrandedPage = ({ children }) => (
  <div className="branded-page">
    <SkyBackdrop />
    {children}
  </div>
)

BrandedPage.propTypes = {
  children: PropTypes.node,
}

export default BrandedPage
